import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const MediaBlockBodyDescription = props => {
  const { children, className, ...other } = props;

  return (
    <p className={clsx("em-c-media-block__desc", className)} {...other}>
      {children}
    </p>
  );
};

MediaBlockBodyDescription.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

MediaBlockBodyDescription.defaultProps = {
  className: "",
  children: null
};

export default MediaBlockBodyDescription;
